/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const recordResponse = /* GraphQL */ `
  mutation RecordResponse($input: createEventResponse) {
    recordResponse(input: $input)
  }
`;
export const confirmAttendance = /* GraphQL */ `
  mutation ConfirmAttendance($talentEventID: String!) {
    confirmAttendance(talentEventID: $talentEventID)
  }
`;
